export const NARRATIVE_MODE_VALUES = ["pov", "external"];
export const NarrativeMode = {
    POV: "pov",
    EXTERNAL: "external",
};
export const NARRATIVE_MODE_LABELS = {
    [NarrativeMode.POV]: "POV — le spectateur est le héros",
    [NarrativeMode.EXTERNAL]: "Caméra externe",
};
